import { render, staticRenderFns } from "./ProductInspections.vue?vue&type=template&id=7e9e6d03"
import script from "./ProductInspections.vue?vue&type=script&lang=ts"
export * from "./ProductInspections.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports